module.exports = __webpack_public_path__ + "static/img/no5.12809934.png";